import React from 'react'
import ReactDOM from 'react-dom'

import { Form } from '@bigfishtv/tank-form-ui'

const CustomForm = (props) => (
  <Form
    {...props}
    // labelProps={{ className: '' }}
    sectionProps={{ className: 'margin-vertical-l margin-first-last-reset' }}
    formBodyProps={{ className: 'margin-vertical-l margin-first-last-reset' }}
    formFooterProps={{ className: 'margin-vertical-l margin-first-last-reset' }}
    sectionTitleProps={{ className: props.sectionTitleClass }}
    sectionFieldsProps={{ className: 'margin-vertical-s grid-form' }}
    inputContainerProps={{ className: 'field margin-vertical-s margin-first-last-reset' }}
    submitButtonProps={{ className: 'button button-dark button-border' }}
  />
)

window.Form = {
  init: (id, props) => {
    ReactDOM.render(<CustomForm {...props} defaultValue={props.initialValue} />, document.getElementById(id))
  },
}
